import ClickObserver from "./ClickObserver";
import AObservableSubject from "./AObservableSubject";

/**
 * Subject that will notify all observers after window resize.
 *
 * @see ClickObserver
 */
 export default class WindowResizeSubject extends AObservableSubject {

  /**
   * Constructor
   */
  constructor() {
    super();

    /**
     * On window resize notify all available observers
     */
    $(window).resize(() => {
      this.notify();
    });
  }
}
